import loadPageStrip from './loadPagestrip';
import React, { useRef, useEffect } from 'react';

const CmsPageStrip = ({ context, rewriteCanonical }) => {
  const pageStripRef = useRef(null);
  const keepTitle = !rewriteCanonical;
  useEffect(() => {
    loadPageStrip(() => {
      const opt = {
        context,
        prevNext: false,
        jackInTheBox: true,
        locale: 'de',
        history: 'hash',
        headingBaseLevel: 2,
        rewriteCanonical: false,
        keepTitle,
        apiBase: 'https://pagestrip.com/',
      };

      window.Kent.renderClient(null, opt, pageStripRef.current);
    });
  }, []);

  return <div ref={pageStripRef} />;
};

export default CmsPageStrip;
